import clsx from 'clsx'
import {orderBy} from 'lodash'
import React from 'react'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import CloseIcon from '@mui/icons-material/Close'
import {toDisplayPoints} from 'helpers/utils'

import FullScreenDialog from 'components/FullScreenDialog'

import Question from './Question'

const useStyles = makeStyles(assessmentStyles)
 
export default function PreviewResultsAssessment ({context, imported}) {
  const classes = useStyles()

  const {quizAssessmentResults: assessment, assessment: assessmentId, translate, link, quizTypesMap} = context
  const {content = {}, results = {}} = assessment
  const {title, type} = content
  const assessmentLoaded = !context.quizSearch['assessment-results']

  const typeName = translate(quizTypesMap[type])

  const sections = assessment.assessmentId == assessmentId
    ? orderBy(Object.values(content.sections || {}),'index')
    : []

  const questions = sections.reduce((questions, section, sectionIndex) => {
    return questions.concat(section.questions.map(q => ({...q, sectionId: section.id})))
  }, [])

  const {points, total} = Object.values(results).reduce((acc, {points, total}) => ({total: acc.total + total, points: acc.points + points}), {total: 0, points: 0})

  const percentageText = `${Math.round(points / total * 100)}%`
  const pointsText = `${translate('points')}: ${toDisplayPoints(points)} ${translate('of')} ${toDisplayPoints(total)}`

  const closeLink = imported ? imported.closeLink : link({action: 'preview', sectionId: undefined, questionId: undefined})

  return (
    <FullScreenDialog open={assessmentLoaded}>
      <Box className={classes.root}>
        <Box className={classes.header}>
          <Box className={classes.pointsWrapper}>
            <Box className={classes.label}>
              {translate('preview-results-header')}
            </Box>
            <Box className={classes.percentage}>
              {percentageText}
            </Box>
            <Box className={classes.points}>
              {pointsText}
            </Box>
          </Box>
          <Box className={classes.rightWrapper}>
            <Box className={classes.buttonWrapper}>
              <Link className={clsx(classes.button, classes.close)} to={closeLink}>
                <Box className="icon"><CloseIcon /></Box>
                <Box className="label">{translate('close')}</Box>
              </Link>
            </Box>
            <Box className={classes.filler} />
            <Box className={classes.notice}>
              {translate('questions-not-autograded-notice')}
            </Box>
          </Box>
        </Box>
        <Box className={classes.preview}>
          {questions.map((question, globalIndex) => (
            <Box key={question.id} className={classes.question}>
              <Question {...{globalIndex, context, sections, question}} />
            </Box>
          ))}
        </Box>
      </Box>
    </FullScreenDialog>
  )
}

export function assessmentStyles (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'hidden'
    },
    header: {
      padding: '10px 20px 10px 10px',
      display: 'flex',
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start'
      }
    },
    pointsWrapper: {
      flexGrow: 1,
    },
    label: {
      color: '#4d5361',
      fontSize:'13pt',
      fontWeight: 'bold'
    },
    percentage: {
      marginTop: 5,
      fontSize:'50pt',
      color: '#df7317'
    },
    points: {
      color: '#4d5361',
      fontSize:'10pt',
    },
    notice: {
      color: '#4d5361',
      fontSize:'10pt',
    },
    filler: {
      flexGrow: 1
    },
    buttonWrapper: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    button: {
      textDecoration: 'none',
      color: '#fff',
      display: 'flex',
      padding: '7px 15px 7px 12px',
      backgroundColor:'#2ca5ec',
      borderRadius: 3,
      '& >div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      '& .label': {
        fontSize: '13pt'
      },
      cursor: 'pointer',
      '&:hover': {
      },
    },
    close: {
      marginLeft: 20,
      '& .icon': {
        marginTop: -3,
        marginRight: 3,
        fontSize: '8pt'
      },
    },
    preview: {
      display: 'flex',
      flexDirection: 'column',
      padding: 10,
      flexGrow: 1,
      overflowY: 'auto'
    },
    question: {
      marginTop: 20,
      border: 'solid 1px #ccc',
      borderRadius: 2,
      backgroundColor: '#fff',
      '&:first-child': {
        marginTop: 0
      }
    }
  }
}
